import Dialog from '@material-ui/core/Dialog';
import '../../styles/emailDialog.css';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import React, { Component } from 'react';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import InvoiceService from '../../services/WebInvoiceService';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '../shared/ppbn-textfield';
import theme from '../../themes/petroff.theme';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = {
    body: {
        margin: '2rem 1rem'
    },
    subject: {
        margin: '1rem',
    },
    chipContainer: {
        height: '60px',
        width: '450px',
    },
    emailsContainer: {
        position: 'relative'
    },
    selectEmails: {
        border: `solid 1px ${theme.palette.common.darkGray}`,
        borderRadius: '4px',
        margin: '1rem'
    },
    label: {
        position: 'absolute',
        top: '-10px',
        fontSize: 'small',
        color: `${theme.palette.common.grayText}`
    },
    selectedChip: {
        background: `${theme.palette.primary.light}`,
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -8,
        marginLeft: -8,
    },
    wrapper: {
        position: 'relative',
    },
}


class InvoiceEmailDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: [],
            subject: '',
            body: '',
            invoiceId : this.props.invoiceId,
            customerId : this.props.customerId,
            selectable : this.props.emails,
            invoiceType : this.props.invoiceType,
            requestStatusOpen : false,
            message : "Email sent.",
            sending : false,
            isError : false,
            isPollingInvoiceSendStatus : false
        }
    }
    
    handleChipClick(email) {
        this.setState({
            selected : [...this.state.selected,email],
            selectable : this.state.selectable.filter( (item) => { return item !== email })            
        })
    }   

    handleChipDelete(email) {        
        this.setState({
            selectable : [...this.state.selectable,email],
            selected : this.state.selected.filter( (item) => { return item !== email }) 
        })
    }

    selectableChips() {        
        return this.state.selectable && this.state.selectable.map((email, i) => {
            return <Chip id={`chip-${i}`} key={i} label={email} onClick={() => this.handleChipClick(email)}/>
        })
    }

    selectedChips() {
        return this.state.selected.map( (email, i) => {            
            return <Chip style={styles.selectedChip} key={i} label={email} onDelete={() => this.handleChipDelete(email)}/>
        });
    }

    generateInvoiceFilename() {
        return "invoice" + this.props.invoiceId + ".pdf";
    }

    onSend() {
        this.setState( {sending : true }, async () => {
            const email = { 
                emails : this.state.selected,
                subject : this.state.subject,
                body : this.state.body
            }
            const response  = await InvoiceService.sendInvoiceSyncNew(email, 
                                                                      this.generateInvoiceFilename(),
                                                                      this.state.customerId,
                                                                      this.state.invoiceId, 
                                                                      this.state.invoiceType);
            // There was a failure to queue
            if('failure' in response) {
                this.showMessage(response);
                this.props.onClose();                
            } else {
                const { jobId } = response
                this.setState( { isPollingInvoiceSendStatus : true}, async () => {
                    await this.pollSendStatus(jobId)
                })
            }            
        })
    }

    pollSendStatus = async (jobId) => {
        const response = await InvoiceService.getInvoiceSendStatus(jobId);        
        
        // We need to handle failed as a job status
        if(this.state.isPollingInvoiceSendStatus && response.jobStatus !== 'finished') {
            setTimeout(() => {
                this.pollSendStatus(jobId)
              }, 2000);            
        } else {            
            this.props.onClose();
            this.showMessage(response);
        }
    }
    
    showMessage = (response) => {
        const isError = 'failure' in response        
        var message = this.state.message
        if(isError && 'message' in response) {
           message = response.message 
        } else if(isError) {
           message = "Failed to send email"
        } else {
            message = "Email sent"
        }

        this.setState({
            requestStatusOpen: true,
            sending: false,
            isPollingInvoiceSendStatus : false,
            isError,
            message
        });
    };

    cleanup() {        
        this.setState({            
            sending: false,
            isPollingInvoiceSendStatus : false,            
        });
        this.props.onClose()
    }

    render() {  
        const openModal = !!this.props.open;
        const {sending, selected} = this.state
        return (
            <div>
                <Dialog className="email-dialog" open={openModal}>
                    <div className="content-text">
                        <DialogTitle id="form-dialog-title">Email Invoice</DialogTitle>
                        <div style={styles.emailsContainer}>
                        <fieldset style={styles.selectEmails}>
                            <legend style={{ width: '35px' }}></legend>
                            <label style={styles.label}>Emails</label>
                            <DialogContentText style={styles.contentText}>
                                Choose an email or emails to send the invoice to.
                            </DialogContentText>
                            <div className="selectable chip-container">
                                {this.selectableChips()}
                            </div>
                            <br />
                            <DialogContentText style={styles.contentText}>
                                Recepients
                            </DialogContentText >
                            <div style={styles.chipContainer} className="selected">
                                {this.selectedChips()}
                            </div>
                        </fieldset>
                        </div>
                        
                        <div style={styles.subject}>
                            <TextField
                                id='subject'
                                maxLength="100"
                                className='email-subject'
                                label='Subject'
                                style={{ width: '300px' }}
                                onChange={e => this.setState({ subject: e.target.value })}
                            />
                        </div>
                        <div style={styles.body}>
                            <TextField
                                id='body'
                                maxLength="1000"
                                className='email-body-textfield'
                                label='Body'
                                style={{ width: '500px' }}
                                rows={3}
                                rowsMax={5}                                
                                variant="outlined"
                                onChange={e => this.setState({ body: e.target.value })}
                                multiline={true} />
                        </div>
                        <DialogActions>
                            <Button onClick={() => this.cleanup()} color="primary">
                                Cancel
                            </Button>
                            <div style={styles.wrapper}>
                                <Button id="send-email-dialog-button" disabled={selected.length === 0 || sending} onClick={() => this.onSend()} color="primary">
                                    Send
                                </Button>
                                {sending && <CircularProgress size={14} style={styles.buttonProgress} /> }
                            </div>
                        </DialogActions>
                    </div>
                </Dialog>
                <Snackbar
                    open={this.state.requestStatusOpen}                    
                    message={this.state.message }
                    autoHideDuration={3000}
                    variant={this.state.isError ? 'failure' : 'success'}                    
                    anchorOrigin={{ vertical: 'top', horizontal: 'center'}}
                    onClose={() => this.setState({ requestStatusOpen: false })}
                />
            </div>
        );
    }
}

export default InvoiceEmailDialog;